export default __webpack_public_path__ + "static/media/brand.6b476dce.svg";